export const COMPLIANCE_DOCUMENT_VERIFICATIONS_TABLE_NAME = 'complianceDocumentVerifications';

// Document table constants

// The columns available to be shown in a documents table.
export const COMPLIANCE_DOCUMENT_VERIFICATIONS_TABLE_COLUMNS = {
  audited_at: { label: 'Audited At', key: 'audited_at' },
  user_id: { label: 'Audited By', key: 'user_id' },
};

export const COMPLIANCE_DOCUMENT_VERIFICATIONS_TABLE_DEFAULT_COLUMNS = [
  COMPLIANCE_DOCUMENT_VERIFICATIONS_TABLE_COLUMNS.user_id,
  COMPLIANCE_DOCUMENT_VERIFICATIONS_TABLE_COLUMNS.audited_at,
];
